import { render, staticRenderFns } from "./live-user-reg.vue?vue&type=template&id=c6c0cac8&scoped=true&"
import script from "./live-user-reg.vue?vue&type=script&lang=js&"
export * from "./live-user-reg.vue?vue&type=script&lang=js&"
import style0 from "./live-user-reg.vue?vue&type=style&index=0&id=c6c0cac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c0cac8",
  null
  
)

export default component.exports